import {Component, OnInit} from '@angular/core';
import {AngularFireAuth} from 'angularfire2/auth';
import {ScheduleService} from '../services/ScheduleService';
import {TranslateService} from '@ngx-translate/core';
import {AngularFireDatabase} from 'angularfire2/database';
import {TimeTrackerService} from '../time-tracker-service.service';
import {User} from '../../models/User';
import {Schedule} from '../../models/Schedule';
import {Observable} from 'rxjs/Observable';
import * as firebase from 'firebase/app';

@Component({
    selector: 'app-score',
    templateUrl: './score.component.html',
    styleUrls: ['./score.component.css']
})
export class ScoreComponent implements OnInit {

    MAX_TOP_USERS = 5;
    MAX_TOP_TEAMS = 3;

    fromDate: Date;
    toDate: Date;
    userInfo: {};
    listAllUsers: User[];
    user: Observable<firebase.User>;

    listUserDelay: Array<any> = [];
    listTopUsers: Array<any> = [];
    listTopTeams: Array<any> = [];
    companyId: string;

    constructor(public afAuth: AngularFireAuth, public af: AngularFireDatabase,
                public tts: TimeTrackerService, public scheduleService: ScheduleService,
                public ts: TranslateService) {
        this.user = this.afAuth.authState;

        this.fromDate = new Date();
        this.toDate = new Date();

        this.fromDate.setHours(0);
        this.fromDate.setMinutes(0);
        this.fromDate.setSeconds(0);
        this.fromDate.setMilliseconds(0);
        this.fromDate.setDate(1);

        this.toDate.setHours(23);
        this.toDate.setMinutes(59);
        this.toDate.setSeconds(59);
        this.toDate.setMilliseconds(999);
        this.toDate.setMonth(this.toDate.getMonth() + 1);
        this.toDate.setDate(0);
    }

    ngOnInit() {
        this.user.subscribe(userInfo => {
            this.userInfo = userInfo;
            // console.log(userInfo);
            if (userInfo) {
                this.tts.getUserFromId(userInfo.uid, userProfile => {
                    const profile: User = userProfile.payload.val();
                    if (profile && profile.isAdmin) {
                        this.companyId = userProfile.payload.val().companyId;
                        this.getAllUsers(this.companyId);
                    } else {
                        console.log('sign out');
                        this.afAuth.auth.signOut();
                    }
                });
            }
        });
    }

    public getAllUsers(companyId) {
        const userSubs = this.af.list<User>(TimeTrackerService.USERS, query => query.orderByChild('companyId').equalTo(companyId))
            .valueChanges()
            .subscribe(listUsers => {
                userSubs.unsubscribe();
                for (let i = 0; i < listUsers.length; i++) { // removing users without teamId
                    if (!listUsers[i].teamId) {
                        listUsers.splice(i, 1);
                        i--;
                    }
                }
                // console.log('listAllScoreUsers', listUsers);
                this.listAllUsers = listUsers;
                this.generateScore(listUsers);
            });
    }

    /**
     * Call User check and schedules to compare hours delay
     * @param {Array<User>} users
     */
    generateScore(users: Array<User>) {
        this.listUserDelay = [];
        const lenUser = users.length;
        let currentUser = 0;
        users.forEach(user => {
            this.tts.getChecks(user.id, user.companyId, this.fromDate.getTime(), this.toDate.getTime(), allChecks => {
                user.checks = this.scheduleService.splitPerDay(allChecks);
                // console.log('user checks: ', user);
                const subs = this.af.list<Schedule>(TimeTrackerService.SCHEDULES, query => query.orderByChild('userId').equalTo(user.id))
                    .valueChanges().subscribe(ref => {
                        subs.unsubscribe();
                        if (ref.length > 0) {
                            user.schedule = ref[0].schedule;
                            let delayTime = 0;
                            user.checks.forEach(checksDay => {
                                if (user.schedule.length > this.scheduleService.getDayFromDate(checksDay.day)) {
                                    delayTime += this.scheduleService.getTimeDelay(checksDay.checks,
                                        user.schedule[this.scheduleService.getDayFromDate(checksDay.day)].hours);
                                }
                            });
                            this.listUserDelay.push({user: user, delay: delayTime});
                        }
                        currentUser++;
                        if (currentUser === lenUser) {
                            this.analyzeScores(this.listUserDelay);
                        }
                    });
            });
        });
    }

    public analyzeScores(alllistUserDelay: Array<any>) {
        // Deleting inactive users
        var listUserDelay: Array<any> = [];
        alllistUserDelay.forEach(userDelay => {
            if (userDelay.user.active) {
                listUserDelay.push(userDelay);
            }
        });

        listUserDelay.sort((a, b) => {
            return (a.user.username > b.user.username) ? 1 : -1;
        });
        listUserDelay.sort((a, b) => {
            return (a.delay > b.delay) ? 1 : -1;
        });

        const teamsMap = [];
        listUserDelay.forEach(userDelay => {
            const teamId = userDelay.user.teamId;
            if (!teamsMap[teamId]) {
                teamsMap[teamId] = {};
                teamsMap[teamId]['delay'] = userDelay.delay;
            } else {
                teamsMap[teamId]['delay'] += userDelay.delay;
            }
        });
        // console.log('teamsMap', teamsMap);

        const teamsDelays = [];
        Object.keys(teamsMap).forEach(teamId => {
            teamsDelays.push({teamId: teamId, delay: teamsMap[teamId].delay});
        });

        teamsDelays.sort((a, b) => {
            return (a.teamId > b.teamId) ? 1 : -1;
        });
        teamsDelays.sort((a, b) => {
            return (a.delay > b.delay) ? 1 : -1;
        });

        this.listTopTeams = [];
        // console.log('teamsDelay', teamsDelays);
        teamsDelays.length = this.MAX_TOP_TEAMS;
        teamsDelays.forEach(teamDelay => {
            const teamSubs = this.af.object(
                TimeTrackerService.COMPANY_DATA + '/' + this.companyId + '/' + TimeTrackerService.TEAMS + '/' + teamDelay.teamId)
                .snapshotChanges()
                .subscribe(data => {
                    teamSubs.unsubscribe();
                    if (data.key) {
                        this.listTopTeams.push({team: data.payload.val(), delay: teamDelay.delay});
                    }
                });
        });

        listUserDelay.length = this.MAX_TOP_USERS;
        this.listTopUsers = listUserDelay;
    }
}



// WEBPACK FOOTER //
// ./src/app/score/score.component.ts